/**
 * Feature Flags Configuration
 * Controls which features are visible in different environments
 */

export interface FeatureFlags {
  okr: boolean;
  meeting: boolean;
  aiTools: boolean;
  teamChat: boolean;
  canvas: boolean;
  dashboard: boolean;
}

// Get current environment
export const ENV = process.env.REACT_APP_ENV || 'production';
export const isProduction = ENV === 'production';
export const isTest = ENV === 'test';

// Feature flags based on environment
export const features: FeatureFlags = {
  okr: process.env.REACT_APP_FEATURE_OKR === 'true',
  meeting: process.env.REACT_APP_FEATURE_MEETING === 'true',
  aiTools: process.env.REACT_APP_FEATURE_AI_TOOLS === 'true',
  teamChat: process.env.REACT_APP_FEATURE_TEAM_CHAT === 'true',
  canvas: process.env.REACT_APP_FEATURE_CANVAS === 'true',
  dashboard: process.env.REACT_APP_FEATURE_DASHBOARD === 'true',
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  return features[feature] === true;
};

// Export for debugging
export const getFeatureStatus = () => {
  console.log('🔧 Environment:', ENV);
  console.log('🎯 Feature Flags:', features);
  return { env: ENV, features };
};
